import { TStyles } from "utils/Styles";

const styles: TStyles = {
  infoButton: { mr: 3 },
};

export default styles;
